module.exports = __webpack_public_path__ + "static/img/login_logo.356e222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_logo.png
// module id = 450
// module chunks = 103